import is from '@sindresorhus/is';
import type { FunctionComponent } from 'react';

import { SkeletonBreadcrumbs } from '../components/SkeletonLoaders';
import { TileBreadcrumbs } from '../components/TileBreadcrumbs';
import { useProfileBreadcrumbs } from '../hooks/use-profile-breadcrumbs';

type ProfileBreadcrumbsProps = {
    readonly architectureId: string;
    readonly clusterId: string;
    readonly currentItemTitle: string;
    readonly familyId: string;
    readonly parentRoleId?: string | undefined;
};

export const ProfileBreadcrumbs: FunctionComponent<ProfileBreadcrumbsProps> = ({
    architectureId,
    clusterId,
    currentItemTitle,
    familyId,
    parentRoleId,
}) => {
    const { breadcrumbItems, isLoading } = useProfileBreadcrumbs({
        architectureId,
        clusterId,
        currentItemTitle,
        familyId,
        parentRoleId,
    });

    if (isLoading) {
        return <SkeletonBreadcrumbs />;
    }

    if (is.emptyArray(breadcrumbItems)) {
        return null;
    }

    return <TileBreadcrumbs items={breadcrumbItems} />;
};
